/* UGC Video Wall — SlashBeauty */
(function () {
  class SlashUgc extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');

      // arrows
      const prev = this.querySelector('[data-scroll-prev]');
      const next = this.querySelector('[data-scroll-next]');
      if (prev) prev.addEventListener('click', () => this.scrollByCard(-1));
      if (next) next.addEventListener('click', () => this.scrollByCard(1));

      // per-video sound toggles
      this.querySelectorAll('[data-card]').forEach((card) => {
        const btn = card.querySelector('[data-sound]');
        const video = card.querySelector('video');
        if (btn && video) {
          btn.addEventListener('click', () => this.toggleSound(video, btn));
        }
      });

      // pause videos that scroll out of view (perf)
      this.initVisibility();
    }

    scrollByCard(dir) {
      const card = this.querySelector('[data-card]');
      if (!card || !this.track) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 16;
      const amount = (card.offsetWidth + gap) * 2 * dir;
      this.track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    toggleSound(video, btn) {
      const turningOn = video.muted;
      // mute all other videos first (only one plays sound at a time)
      this.querySelectorAll('video').forEach((v) => {
        v.muted = true;
      });
      this.querySelectorAll('[data-sound]').forEach((b) => {
        b.setAttribute('aria-pressed', 'false');
        b.classList.add('is-muted');
      });

      if (turningOn) {
        video.muted = false;
        video.play().catch(() => {});
        btn.setAttribute('aria-pressed', 'true');
        btn.classList.remove('is-muted');
      }
    }

    initVisibility() {
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
              video.muted = true;
              const b = entry.target.querySelector('[data-sound]');
              if (b) { b.classList.add('is-muted'); b.setAttribute('aria-pressed', 'false'); }
            }
          });
        },
        { root: this.track, threshold: 0.5 }
      );
      this.querySelectorAll('[data-card]').forEach((c) => io.observe(c));
    }
  }

  if (!customElements.get('slash-ugc')) {
    customElements.define('slash-ugc', SlashUgc);
  }
})();